export default __webpack_public_path__ + "static/media/cargando.d531c5ab.png";